import { Injectable } from '@angular/core';
import { BaseReportActionsHandler } from '../base-report-actions-handler';
import * as _ from 'underscore';
import { WorkflowDataService } from '../../../services/workflow/workflow-data.service';
import { IObject } from '../../../../../type_definitions/datatypes';
import { Override } from '../../../app-decorators';

@Injectable()
export class StatusPreconditionService extends BaseReportActionsHandler {
  constructor(
    private workflowDataService: WorkflowDataService
  ) {
    super();
  }

  @Override(BaseReportActionsHandler)
  public execute(): Promise<string | void> {
    if (this.isWorkflowTypeMixed() && this.applyOnCurrentAction()) {
      return Promise.reject('In order to execute your action you need to select only orders or only quotes.');
    }

    return Promise.resolve();
  }

  // definitions to check if the precondition applies to the current action
  private applyOnCurrentAction(): boolean {
    const actionsToApply: string[] = [
      'ADD_STATUS',
      'CLOSE_ORDER_PENDING'
    ];

    return _.contains(actionsToApply, this.action.code);
  }

  // returns true in case that is selected a mix of orders and quote
  private isWorkflowTypeMixed(): boolean {
    const poSelected: boolean = !!_.find(this.rowSelection, (selection: IObject) => this.workflowDataService.isOrderRow(selection, this.action.mapping));
    const pqSelected: boolean = !!_.find(this.rowSelection, (selection: IObject) => this.workflowDataService.isQuoteRow(selection, this.action.mapping));
    return poSelected && pqSelected;
  }
}